<template>
  <section>
    <div class="left">
      <h2 v-translate>Poskytovatelé reklam</h2>
    </div>
    <div class="right">
      <SortableCheckboxList
          v-if="advertisingProviders.length > 0"
          :items="advertisingProviders"
          v-model="entity.advertising_providers_order"
          :disabled="!isEditable"
          :allow-sorting="true"
          name="advertisingProviders"
      >
      </SortableCheckboxList>
    </div>
  </section>
</template>

<script>

import SortableCheckboxList from "../../../common/SortableCheckboxList.vue";

export default {
  name: "AdvertisingProviders",
  components: { SortableCheckboxList },
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      advertisingProviders: [],
    }
  },
  created(AdvertisingProviderService) {
    this.advertisingProviderService = AdvertisingProviderService;
    this.advertisingProviderService.getEntities()
        .then((data) => {
          this.advertisingProviders = data['advertisingProviders']
        })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/Forms/AdvertisingProviders.vue